// TODO : once api available this respoce need to come from BE
export const jobTitleOptions = [
  { label: 'Analyst', value: 'Analyst' },
  { label: 'Automation Architect', value: 'Automation Architect' },
  { label: 'CEO', value: 'CEO' },
  { label: 'CTO', value: 'CTO' },
  { label: 'Consultant', value: 'Consultant' },
  { label: 'Director', value: 'Director' },
  { label: 'DevOps Engineer', value: 'DevOps Engineer' },
  { label: 'Engineering Manager', value: 'Engineering Manager' },
  { label: 'Development Engineer', value: 'Development Engineer' },
  { label: 'Manager', value: 'Manager' },
  { label: 'QA Engineer', value: 'QA Engineer' },
  { label: 'QA Lead', value: 'QA Lead' },
  { label: 'Service Provider', value: 'Service Provider' },
  { label: 'Software Engineer', value: 'Software Engineer' },
  { label: 'VP', value: 'VP' },
  { label: 'Others', value: 'Others' },
];
